import { render, staticRenderFns } from "./sub-navigation.vue?vue&type=template&id=1d2d84f4&"
import script from "./sub-navigation.vue?vue&type=script&lang=js&"
export * from "./sub-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports